<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="alllot"/>
        <MenuStockList/>
        <LotDetailInEditList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import LotDetailInEditList from '@/components/menuadmin/stock/stocklist/LotDetailInEditList.vue'

export default {
    name:'lotDetailInEdit',
    components:{
        HeaderStock,
        MenuStockList,
        LotDetailInEditList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>